import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$d4df from '/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as contentfulRuntime$0dfb from '/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/node_modules/@nuxt/image/dist/runtime/providers/contentful.js'
import * as ipxRuntime$dd73 from '/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 600,
    "md": 960,
    "lg": 1264,
    "xl": 1904,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$d4df, defaults: {} },
  ['contentful']: { provider: contentfulRuntime$0dfb, defaults: {"baseURL":"https://images.ctfassets.net","modifiers":{"q":"100"}} },
  ['ipx']: { provider: ipxRuntime$dd73, defaults: {} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
